import { Component, ElementRef, Inject, Injector} from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import * as jQuery from "jquery";
import { DataService } from "../../../services/data/data.service";
import { TradeRequestModel } from '../../../model/trade.request.data';
import { Ticket } from '../../tradedeskTabs/orders/tradeskOrdersTab/tradeskOrdersTab.component';
import { AppComponentBase } from "../../../services/AppComponentBase";


@Component({
    selector: "modal-yesno",
    template: require('./yesno.component.html'),
    styles: [require('./yesno.component.css')]
})

export class YesNoModal extends AppComponentBase  {

    
    constructor(
        private router: Router,
        private fb: FormBuilder,
        public activeModal: NgbActiveModal,
        public dataService: DataService,
        injector: Injector,
    ) {
        super(injector);
    }

    private _title: string = "";
    public get title (): string {
        return this._title;
    }
    public set title ( value: string ) {
        this._title = value;
    }

    private _message: string = "";
    public get message (): string {
        return this._message;
    }
    public set message ( value: string ) {
        this._message = value;
    }

    public acceptAction()
    {
     //   alert("ACCEPT");
        this.callBackComponent.acceptAction(this.params);
    }

    public cancelAction()
    {
        if(this.cancelCallBack)
        this.callBackComponent.cancelAction(this.params);
    }

    private _cancelCallBack: boolean = false;
    public get cancelCallBack(): boolean {
        return this._cancelCallBack;
    }
    public set cancelCallBack(value: boolean) {
        this._cancelCallBack = value;
    }

    public updateData(title:string,message:string, callbackComponent:any, params:any,cancelCallBack:boolean=false, isHeadLogo?:boolean, logoUrl?:string)
    {
        this.title = title;
        this.message = message;
        this.callBackComponent = callbackComponent;
        this.params = params;
        this.cancelCallBack = cancelCallBack;

        if(isHeadLogo)
        this.isHeadLogo = isHeadLogo;

        if(logoUrl)
        this.logoUrl = logoUrl;
    }

    public callBackComponent:any;
    public params:any;


    public isHeadLogo:boolean = false;
    public logoUrl:string="";

}

export function ShowYesNoOrderModal(modalService: NgbModal){
    let m:NgbModalRef= modalService.open(YesNoModal,{
        backdrop: "static",
        size: "sm",
        centered: true, 
        windowClass: "dark-modal"
    });
    let modal = (<YesNoModal>m.componentInstance);
    
    return modal

}
